/**
 * The one copyright line every ComplyEdge footer shows: the website partial,
 * the dashboard and the trust pages all build it here, so they cannot drift.
 * The start year is the platform's first commit (2025-08-06); the end year is
 * the reader's current year, so the line never goes stale.
 */
export const COPYRIGHT_START_YEAR = 2025
export const COPYRIGHT_HOLDER = 'ComplyEdge'

export function copyrightYears(now = new Date().getFullYear()) {
  return now > COPYRIGHT_START_YEAR ? `${COPYRIGHT_START_YEAR}-${now}` : `${COPYRIGHT_START_YEAR}`
}

export function copyrightLine(now) {
  return `© ${copyrightYears(now)} ${COPYRIGHT_HOLDER}. All rights reserved.`
}

/** The same line in three parts, so a page can bold the holder (brand.js). */
export function copyrightParts(now) {
  return [`© ${copyrightYears(now)} `, COPYRIGHT_HOLDER, '. All rights reserved.']
}
